/**
 * 生産履歴
 */
export const ProductionHistoryConst = 
{
  /**
   * 有
   */
  YES: 1,
  /**
   * 無
   */
  NO: 2,
} as const;
export type  ProductionHistoryType = typeof ProductionHistoryConst[keyof typeof ProductionHistoryConst];

export const ProductionHistoryOptions: {value: ProductionHistoryType; label: string; color: string }[] = [
    {value: ProductionHistoryConst.YES, label: '有', color:  'bg-gray-100 text-gray-800' },
    // {value: ProductionHistoryConst.NO, label: '無', color:  'bg-gray-100 text-gray-800' },
];